// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__TXpgM","cardContainer":"styles_cardContainer__pyn+X","card":"styles_card__NkDPp","extensionsContainer":"styles_extensionsContainer__Q+Lgf"};